var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFabitsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 32,
    viewBox: "0 0 116 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9941 9.93495V31.3244H36.6927V29.3034C35.3661 30.9876 33.2103 31.9981 30.5571 31.9981C25.0848 31.9981 20.6074 27.1139 20.6074 20.7139C20.6074 14.3139 25.0848 9.42969 30.5571 9.42969C33.3761 9.42969 35.3661 10.4402 36.6927 12.1244V9.93495H42.9941ZM36.6927 20.5455C36.6927 17.3455 34.5369 15.3244 31.7179 15.3244C28.8988 15.3244 26.743 17.3455 26.743 20.5455C26.743 23.7455 28.8988 25.7665 31.7179 25.7665C34.7028 25.7665 36.6927 23.7455 36.6927 20.5455Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0234 20.5477C70.0234 26.9477 65.5461 31.8319 60.0738 31.8319C57.2547 31.8319 55.2648 30.8213 53.9382 29.1371V31.1582H47.6367V1.34766H53.9382V11.9582C55.2648 10.274 57.4205 9.26344 60.0738 9.26344C65.5461 9.26344 70.0234 14.1477 70.0234 20.5477ZM63.722 20.5477C63.722 17.3477 61.5662 15.3266 58.7472 15.3266C55.9281 15.3266 53.7723 17.3477 53.7723 20.5477C53.7723 23.7477 55.9281 25.7687 58.7472 25.7687C61.7321 25.7687 63.722 23.7477 63.722 20.5477Z",
    fill: "#F6F6F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.911 16.0013V23.5803C91.911 25.4329 93.4034 25.6013 96.2225 25.4329V31.3276C88.0969 32.1697 85.6095 29.6434 85.6095 23.5803V16.0013H82.293V9.93816H85.6095V5.72763L91.911 3.875V9.93816H96.2225V16.1697H91.911V16.0013Z",
    fill: "#F6F6F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.627 24.9249C115.627 29.8091 111.481 31.9986 107.004 31.9986C102.858 31.9986 99.7071 30.3143 98.0488 26.9459L103.521 23.7459C104.019 25.4301 105.179 26.2722 107.004 26.2722C108.496 26.2722 109.325 25.767 109.325 24.9249C109.325 22.567 99.0438 23.7459 99.0438 16.3354C99.0438 11.6196 102.858 9.26172 107.169 9.26172C110.486 9.26172 113.471 10.7775 115.295 13.8091L109.988 16.8407C109.325 15.6617 108.496 14.988 107.169 14.988C106.009 14.988 105.345 15.4933 105.345 16.167C105.345 18.5249 115.627 17.0091 115.627 24.9249Z",
    fill: "#F6F6F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7869 1.34766H0.375V7.57924H17.7869V1.34766Z",
    fill: "#F6F6F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.375 13.8086V31.4928H7.0081V20.0402H17.7869V13.8086H0.375Z",
    fill: "#F6F6F6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3054 4.04211C80.3054 6.23158 78.4813 8.08421 76.3256 8.08421C74.1698 8.08421 72.3457 6.23158 72.3457 4.04211C72.3457 1.85263 74.1698 0 76.3256 0C78.4813 0 80.3054 1.85263 80.3054 4.04211Z",
    fill: "#82B770"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3094 9.9375H73.1738V31.4954H79.3094V9.9375Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFabitsLogo);
export default __webpack_public_path__ + "static/media/Fabits-Logo.c4c8d7a1e6767c0f0ed9d4f89d90eae1.svg";
export { ForwardRef as ReactComponent };